<template>
  <div id="app">
    <navHeader></navHeader>
    <router-view style="min-height: 100vh"></router-view>
    <Footer></Footer>
    <mobileFooter></mobileFooter>
  </div>
</template>

<script>
import Footer from '@/components/footer.vue'
import mobileFooter from '@/components/mobileFooter.vue'
import navHeader from '@/components/navHeader.vue'
export default {
  name: 'App',
  components: {
    Footer,
    mobileFooter,
    navHeader
  },
  mounted() {
    
  }
}
</script>

<style lang="less">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #333333;
  // height: 100%;
  // overflow: auto;
  div {
    box-sizing: border-box;
  }
}
body,
html {
  margin: 0;
  padding: 0;
  text-align: left;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */ {
  opacity: 0.3;
}
/* fade-transform */

.fade-transform-leave-active,
.fade-transform-enter-active {
  transition: all 0.3s;
}

.fade-transform-enter {
  opacity: 0;
  transform: translateY(-90vw);
}

.fade-transform-leave-to {
  opacity: 0;
  transform: translateY(90vw);
}
// scale-slide
.scale-slide-enter-active,
.scale-slide-leave-active {
  position: absolute;

  transition: all 0.85s ease;
}

.scale-slide-enter-from {
  left: -100%;
}

.scale-slide-enter-to {
  left: 0%;
}

.scale-slide-leave-from {
  transform: scale(1);
}

.scale-slide-leave-to {
  transform: scale(0.8);
}

.nav-scrolled {
  background-color: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(8px);
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
}
</style>
